import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {Photo, Sector, Site} from "../../models/data.model";
import {DataProvider} from "../../providers/data/data";
import {PhotosViewerPage} from "../photos-viewer/photos-viewer";

@IonicPage()
@Component({
  selector: 'page-site',
  templateUrl: 'site.html'
})
export class SitePage {

  siteId : number;
  photos: Photo[] = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private  data: DataProvider) {
    this.siteId = navParams.data;
    this.photos = this.getSite().photos.map(photo => {
      return {
        name: photo,
        url: DataProvider.getPhotoUrl(photo, false)
      }
    });
  }

  protected getSite(): Site {
    return this.data.getSite(this.siteId);
  }

  protected openPhotoGallery() {
    this.navCtrl.push(PhotosViewerPage, {
      photos: this.photos,
    }).catch();
  }

  protected clickText(event: Event) {
    const element: HTMLElement = <HTMLElement>event.target;
    if (element.nodeName != "IMG") return;
    const photo: Photo = {
      name: "photo",
      url: (<HTMLImageElement>element).src
    };
    this.navCtrl.push(PhotosViewerPage, {
      photos: [photo]
    }).catch();
  }

  protected getSectors(): Sector[] {
    return this.getSite().sectors;
  }


}



// WEBPACK FOOTER //
// ./src/pages/site/site.ts